import React, { Component } from "react";
import { Modal, Form, Row, Col, Button, Tabs, Table, Tooltip, DatePicker } from "antd";
import InputForm from "./InputForm";
import "./Form.css";
import axios from 'axios';
import { maskDate } from "../utils/Masker";
import moment from "moment-timezone";
import numeral from "numeral";
import PessoaFrame from './PessoaFrame';
import TipoDocFrame from './TipoDocFrame';
import CondPagtoFrame from './CondPagtoFrame';
import NotaFiscalServicoItemForm from './NotaFiscalServicoItemForm';
import TituloParcelaForm from './TituloParcelaForm';
import ModalPadraoForm from './ModalPadraoForm';
import SpinnerForm from './SpinnerForm';
import { getUsuario } from "../utils/LoginManager";
import Colors from "../utils/Colors";

const { Item: ItemForm } = Form;
const TabPane = Tabs.TabPane;
const { Column } = Table;
const ButtonGroup = Button.Group;





export default class NotaFiscalServicoEmissaoForm extends Component {

  state = {
    registro: {},
    modalServicoVisible: false,
    modalParcelaVisible: false,
    modalListaVisible: false,

    carregandoForm: false,
    visualizando: false,
    caixaFechado: false,

    activeKey: "servicos",

    OPCOES_COMBO_EMITENTE: [],

    listaServicos: [],

    listaParcelas: [],
    vlrTotalParc: 0,
    vlrDifParc: 0,

  };



  componentDidMount() {
    const usuario = getUsuario();
    this.setState({ usuario });
  }

  componentDidUpdate(propsAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      // console.log('componentDidUpdate', this.props.registroSelecionado)

      let caixaFechado = false;
      if (this.props.registroSelecionado.listaParcelas) {
        for (var x in this.props.registroSelecionado.listaParcelas) {
          if (this.props.registroSelecionado.listaParcelas[x].cx_situacao === 0) {
            caixaFechado = true;
          }
        };
      }

      this.setState({
        registro: this.props.registroSelecionado.dados,
        nf_destinatario: this.props.registroSelecionado.dados.nf_destinatario,

        listaServicos: this.props.registroSelecionado.listaServicos ? this.props.registroSelecionado.listaServicos : [],
        listaParcelas: this.props.registroSelecionado.listaParcelas ? this.props.registroSelecionado.listaParcelas : [],

        caixaFechado,
        visualizando: this.props.registroSelecionado.visualizar,
        activeKey: "servicos",
      }, () => {
        this.calculoTotalPedido(this.props.registroSelecionado.listaServicos ? this.props.registroSelecionado.listaServicos : [])

        this.onBuscaEmissor()
        this.forceUpdate()
      });

      if (this.props.registroSelecionado.dados.nf_idf) {
        this.setState({
          activeKey: "servicos",
        });
      }
    }
  }





  onChangeEmitente = event => {
    const { registro, OPCOES_COMBO_EMITENTE } = this.state;

    const value = event.target.value;
    const id = event.target.id;
    const iInd = OPCOES_COMBO_EMITENTE.findIndex(registro => String(registro.key) === String(value.key));

    registro[id] = value;
    this.setState({
      [id]: value,
      registro: {
        ...this.state.registro,
        nf_serie: this.props.registroSelecionado.dados.nf_idf ? this.props.registroSelecionado.dados.nf_serie : OPCOES_COMBO_EMITENTE[iInd].enf_nfse_serie > 0 ? OPCOES_COMBO_EMITENTE[iInd].enf_nfse_serie : 0,
      },
    });
  };

  onBuscaEmissor = async () => {
    this.setState({ OPCOES_COMBO_EMITENTE: [] })
    axios.get('/emitenteNF/lista', {
      params: {
        tipo: 'SERV',
      }
    }).then(response => {
      const { data } = response;

      let lista = [];
      for (var x in data) {
        lista.push({
          key: String(data[x].enf_idf),
          label: data[x].enf_cnpj + ' - ' + data[x].enf_razao_social + ' [' + (data[x].enf_ambiente === 1 ? 'P' : 'H') + ']',
          enf_emissao_padrao: data[x].enf_emissao_padrao,
          enf_cnpj: data[x].enf_cnpj,
          enf_ambiente: data[x].enf_ambiente,
          enf_nfse_numero: data[x].enf_nfse_numero,
          enf_nfse_serie: data[x].enf_nfse_serie,
          enf_token: data[x].enf_token,
        });
      };

      this.setState({
        registro: {
          ...this.state.registro,
          nf_emitente: this.props.registroSelecionado.dados.nf_idf ? this.props.registroSelecionado.dados.nf_emitente : lista.length ? lista[0] : { key: '', label: '', },
        },
        OPCOES_COMBO_EMITENTE: lista,
      })
    }).catch(error => {
      console.error(error.response);
    })
  };





  onOK = (transmitir) => {
    const { registro, listaServicos, listaParcelas } = this.state;

    if ((!registro.nf_dt_emissao) || (!moment(registro.nf_dt_emissao, 'DD/MM/YYYY', true).isValid())) {
      Modal.warning({ title: 'Aviso!', content: 'Informe uma Data de Emissão Válida' });
      return;
    }
    if ((!registro.nf_dt_inclusao) || (!moment(registro.nf_dt_inclusao, 'DD/MM/YYYY', true).isValid())) {
      Modal.warning({ title: 'Aviso!', content: 'Informe uma Data de Ent/Sai Válida' });
      return;
    }
    if ((!registro.nf_destinatario) || (registro.nf_destinatario.key === '0') || (registro.nf_destinatario.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Destinatário', });
      return;
    }
    if ((!registro.nf_emitente) || (registro.nf_emitente.key === '0') || (registro.nf_emitente.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Emissor', });
      return;
    }

    if ((!listaServicos) || (listaServicos.length === 0)) {
      Modal.warning({ title: 'Aviso!', content: 'Inclua algum serviço na Nota' });
      return;
    }
    if ((listaParcelas) && (listaParcelas.length > 0)) {
      let vlrTotalParc = 0
      for (var x in listaParcelas) {
        vlrTotalParc = vlrTotalParc + parseFloat(listaParcelas[x].tparc_valor);
      };
      let vlrDifParc = parseFloat((parseFloat(vlrTotalParc) - parseFloat(registro.nf_vlr_total)).toFixed(2));
      if (vlrDifParc !== 0) {
        Modal.warning({ title: 'Aviso!', content: 'O Valor Total da Nota não Confere com o Valor Total das parcelas' });
        return;
      }
    }

    const reg = {
      nf_tipo: 'NFSe',
      nf_idf: registro.nf_idf,
      nf_modelo: 99,
      nf_numero: registro.nf_numero ? registro.nf_numero : 0,
      nf_serie: registro.nf_serie ? registro.nf_serie : 0,
      nf_dt_emissao: moment(registro.nf_dt_emissao, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      nf_dt_inclusao: moment(registro.nf_dt_emissao, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      nf_emitente: registro.nf_emitente.key,
      nf_destinatario: registro.nf_destinatario.key,

      nf_vlr_produtos: registro.nf_vlr_produtos,
      nf_vlr_iss: registro.nf_vlr_iss,
      nf_vlr_csll: registro.nf_vlr_csll,
      nf_vlr_inss: registro.nf_vlr_inss,
      nf_vlr_irrf: registro.nf_vlr_irrf,
      nf_vlr_desconto: registro.nf_vlr_desconto,
      nf_vlr_total: registro.nf_vlr_total,

      nf_obs_interna: registro.nf_obs_interna ? registro.nf_obs_interna : '',
      nfinf_texto: registro.nfinf_texto ? registro.nfinf_texto : '',

      nf_tipo_doc: registro.nf_tipo_doc.key,
      nf_cond_pagto: registro.nf_cond_pagto.key,

      listaServicos,
      listaParcelas,

      transmitir: transmitir,
    };


    this.props.onSalvarClick(reg);
  };

  calculoTotalPedido = (listaServicos) => {
    const { registro } = this.state;

    // console.log('calculoTotalPedido', listaServicos)

    let vlrProdutos = 0;
    let vlrISS = 0;
    let vlrCSLL = 0;
    let vlrINSS = 0;
    let vlrIRRF = 0;
    let vlrDesconto = 0;
    let vlrTotal = 0;

    for (var x in listaServicos) {
      vlrProdutos = vlrProdutos + ((parseFloat(listaServicos[x].nfs_qtde) * parseFloat(listaServicos[x].nfs_vlr_unit)) - parseFloat(listaServicos[x].nfs_vlr_desc));
      vlrISS = vlrISS + parseFloat(listaServicos[x].nfs_vlr_iss);
      vlrCSLL = vlrCSLL + parseFloat(listaServicos[x].nfs_vlr_csll);
      vlrINSS = vlrINSS + parseFloat(listaServicos[x].nfs_vlr_inss);
      vlrIRRF = vlrIRRF + parseFloat(listaServicos[x].nfs_vlr_irrf);
      vlrDesconto = vlrDesconto + parseFloat(listaServicos[x].nfs_vlr_desc);
      vlrTotal = vlrTotal + ((parseFloat(listaServicos[x].nfs_qtde) * parseFloat(listaServicos[x].nfs_vlr_unit)) - parseFloat(listaServicos[x].nfs_vlr_desc));
    };

    vlrProdutos = parseFloat(vlrProdutos.toFixed(2));
    vlrISS = parseFloat(vlrISS.toFixed(2));
    vlrCSLL = parseFloat(vlrCSLL.toFixed(2));
    vlrINSS = parseFloat(vlrINSS.toFixed(2));
    vlrIRRF = parseFloat(vlrIRRF.toFixed(2));
    vlrDesconto = parseFloat(vlrDesconto.toFixed(2));
    vlrTotal = parseFloat(vlrTotal.toFixed(2));

    registro.nf_vlr_produtos = vlrProdutos;
    registro.nf_vlr_iss = vlrISS;
    registro.nf_vlr_csll = vlrCSLL;
    registro.nf_vlr_inss = vlrINSS;
    registro.nf_vlr_irrf = vlrIRRF;
    registro.nf_vlr_desconto = vlrDesconto;
    registro.nf_vlr_total = vlrTotal;

    this.setState({
      registro: {
        ...registro
      },
    });
  }








  // ----------------------------------------------------------------
  // SERVIÇOS
  // ----------------------------------------------------------------

  onFecharModalServicoClick = () => {
    this.setState({
      modalServicoVisible: false,
    });
  }

  onSalvarServicoClick = (listaServicos) => {
    this.setState({
      modalServicoVisible: false,
      listaServicos,
    },
      this.calculoTotalPedido(listaServicos)
    );
  }

  onNovoServico = (event) => {
    // if ((!this.state.nf_destinatario) || (this.state.nf_destinatario.key === '') || (this.state.nf_destinatario.key === '0')) {
    //   Modal.warning({ title: 'Aviso!', content: 'Informe o Destinatário da Nota', });
    //   return;
    // }

    this.setState({
      modalServicoVisible: true,
      servicoSelecionado: {
        listaServicos: this.state.listaServicos,
        registro: {
          nfs_seq: 0,
          nfs_servico: { key: '0' },
          nfs_cod_servico: '',
          nfs_cod_nbs: '',
          nfs_descricao: '',

          nfs_qtde: 1,
          nfs_vlr_unit: 0,
          nfs_perc_desc: 0,
          nfs_vlr_desc: 0,
          nfs_vlr_total: 0,

          nfs_bc_iss: 0,
          nfs_perc_iss: 0,
          nfs_vlr_iss: 0,

          nfs_bc_csll: 0,
          nfs_perc_csll: 0,
          nfs_vlr_csll: 0,

          nfs_bc_inss: 0,
          nfs_perc_inss: 0,
          nfs_vlr_inss: 0,

          nfs_bc_irrf: 0,
          nfs_perc_irrf: 0,
          nfs_vlr_irrf: 0,

          nfs_cst: { key: '' },
          nfs_sit_trib_ibs_cbs: '',
          nfs_bc: 0,
          nfs_pibs_mun: 0,
          nfs_vibs_mun: 0,
          nfs_pibs_est: 0,
          nfs_vibs_est: 0,
          nfs_pcbs: 0,
          nfs_vcbs: 0,
        }
      }
    });
  }

  onEditarServicosClick = (reg, visualizar) => {
    this.setState({
      modalServicoVisible: true,
      servicoSelecionado: {
        listaServicos: this.state.listaServicos,
        visualizar,

        registro: {
          nfs_seq: reg.nfs_seq,

          nfs_servico: {
            key: String(reg.nfs_servico),
            label: reg.nfs_descricao,
            serv_valor: 0,
            serv_cod_nfse: String(reg.nfs_cod_servico),
            serv_cod_nbs: String(reg.nfs_cod_nbs),
            serv_aliq_nfse: 0,
            serv_descricao_nfse: reg.nfs_descricao,
          },

          nfs_cod_servico: reg.nfs_cod_servico,
          nfs_cod_nbs: reg.nfs_cod_nbs,
          nfs_descricao: reg.nfs_descricao,

          nfs_qtde: reg.nfs_qtde,
          nfs_vlr_unit: reg.nfs_vlr_unit,
          nfs_qtde: reg.nfs_qtde,
          nfs_perc_desc: reg.nfs_perc_desc,
          nfs_vlr_desc: reg.nfs_vlr_desc,
          nfs_vlr_total: reg.nfs_vlr_total,


          nfs_bc_iss: reg.nfs_bc_iss,
          nfs_perc_iss: reg.nfs_perc_iss,
          nfs_vlr_iss: reg.nfs_vlr_iss,

          nfs_bc_csll: reg.nfs_bc_csll,
          nfs_perc_csll: reg.nfs_perc_csll,
          nfs_vlr_csll: reg.nfs_vlr_csll,

          nfs_bc_inss: reg.nfs_bc_inss,
          nfs_perc_inss: reg.nfs_perc_inss,
          nfs_vlr_inss: reg.nfs_vlr_inss,

          nfs_bc_irrf: reg.nfs_bc_irrf,
          nfs_perc_irrf: reg.nfs_perc_irrf,
          nfs_vlr_irrf: reg.nfs_vlr_irrf,

          nfs_cst: { key: String(reg.nfs_cst).padStart(3, '0') },
          nfs_sit_trib_ibs_cbs: reg.nfs_sit_trib_ibs_cbs,
          nfs_bc: reg.nfs_bc,
          nfs_pibs_mun: reg.nfs_pibs_mun,
          nfs_vibs_mun: reg.nfs_vibs_mun,
          nfs_pibs_est: reg.nfs_pibs_est,
          nfs_vibs_est: reg.nfs_vibs_est,
          nfs_pcbs: reg.nfs_pcbs,
          nfs_vcbs: reg.nfs_vcbs,
        }
      }
    });
  }

  onExcluirServicoClick = (reg) => {
    Modal.confirm({
      title: 'Confirmação de Exclusão',
      content: `Deseja excluir este Serviço?`,
      okText: 'Sim',
      cancelText: 'Não',
      onOk: () => {
        const listaServicos = [...this.state.listaServicos];
        const index = listaServicos.findIndex(registro => registro.nfs_servico);
        listaServicos.splice(index, 1);
        this.setState({
          listaServicos,
        },
          this.calculoTotalPedido(listaServicos)
        );
      }
    })
  }

  renderAcoesServicos = (registro) => {
    return (
      <ButtonGroup size="small">
        {this.state.visualizando || this.state.caixaFechado ? (
          <Tooltip title="Visualizar">
            <Button type="ghost" size="small" onClick={() => this.onEditarServicosClick(registro, true)} icon="eye" />
          </Tooltip>
        ) : (
          <Tooltip title="Editar">
            <Button type="primary" onClick={() => this.onEditarServicosClick(registro, false)} icon="edit" />
          </Tooltip>
        )}
        {this.state.visualizando || this.state.caixaFechado ? null : (
          <Tooltip title="Excluir">
            <Button type="danger" onClick={() => this.onExcluirServicoClick(registro)} icon="delete" />
          </Tooltip>
        )}
      </ButtonGroup>
    );
  };

  // ----------------------------------------------------------------
  // FIM SERVIÇOS
  // ----------------------------------------------------------------








  // ----------------------------------------------------------------
  // PARCELAS
  // ----------------------------------------------------------------

  montaParcelas = () => {
    let listaNova = [];
    if ((!this.state.registro.nf_tipo_doc) || (this.state.registro.nf_tipo_doc.key === '0') || (this.state.registro.nf_tipo_doc.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe o Tipo de Documento', });
      return;
    }

    if ((!this.state.registro.nf_cond_pagto) || (this.state.registro.nf_cond_pagto.key === '0') || (this.state.registro.nf_cond_pagto.key === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Condição de Pagamento', });
      return;
    }

    if (parseFloat(this.state.registro.nf_vlr_total) > 0) {
      const w_cc = this.state.usuario.par_cta_corrente_padrao;
      const w_cc_Desc = this.state.usuario.cc_descricao;
      const w_Qtde_Parc = parseInt(this.state.registro.nf_cond_pagto.qtdeParc);
      const w_Parc_AVista = this.state.registro.nf_cond_pagto.parcAVista;
      const w_Data_Emissao = moment(this.state.registro.nf_dt_emissao, 'DD/MM/YYYY').format('YYYY-MM-DD');
      let w_Data_Parc = moment(this.state.registro.nf_dt_emissao, 'DD/MM/YYYY').format('YYYY-MM-DD')
      let w_Sit = w_Qtde_Parc === 0 ? 'F' : 'A';
      let w_Valor_Parc = parseFloat(parseFloat(this.state.registro.nf_vlr_total) / w_Qtde_Parc).toFixed(2);

      if (w_Parc_AVista) {
        w_Data_Parc = moment(this.state.registro.nf_dt_emissao, 'DD/MM/YYYY').format('YYYY-MM-DD');
        w_Sit = 'P'
      } else {
        w_Data_Parc = moment(w_Data_Emissao).subtract(-1, 'months').format('YYYY-MM-DD');
      }

      let iParc = 1;
      while (iParc <= w_Qtde_Parc) {
        if (iParc > 1) { w_Sit = 'A' };

        listaNova.push({
          tparc_parcela: iParc,
          tparc_data_parcela: w_Data_Parc,
          tparc_tipo_doc: String(this.state.registro.nf_tipo_doc.key),
          tparc_conta_corrente: w_cc,
          tparc_valor: w_Valor_Parc,
          tparc_situacao: w_Sit,
          tparc_obs: '',
          td_descricao: this.state.registro.nf_tipo_doc.label,
          cc_descricao: w_cc_Desc,
          situacao_parcela: w_Sit === 'A' ? 'ABERTO' : 'PAGO',
          pgto_vlr_desconto: 0,
          pgto_vlr_acrescimo: 0,
          pgto_vlr_pago: w_Sit === 'P' ? w_Valor_Parc : 0,
          pgto_vlr_restante: 0,
          pgto_data: w_Sit === 'P' ? w_Data_Parc : '',
          pgto_cta_corrente: w_cc,
        })

        w_Data_Parc = moment(w_Data_Parc).subtract(-1, 'months').format('YYYY-MM-DD');
        iParc++;
      }

      if ((listaNova) && (listaNova.length > 0)) {
        let vlrTotalParc = 0;
        for (var x in listaNova) {
          vlrTotalParc = vlrTotalParc + parseFloat(listaNova[x].tparc_valor);
        };

        if (parseFloat(vlrTotalParc) !== parseFloat(this.state.registro.nf_vlr_total)) {
          let vlrDif = parseFloat((parseFloat(vlrTotalParc) - parseFloat(this.state.registro.nf_vlr_total)).toFixed(2));

          vlrDif = vlrDif * (-1);

          const vlr = (parseFloat(listaNova[0].tparc_valor) + parseFloat(vlrDif)).toFixed(2);

          listaNova[0].tparc_valor = vlr;
          listaNova[0].pgto_vlr_pago = listaNova[0].tparc_situacao === 'P' ? vlr : 0;
        }
      }

    }

    // console.log('listaNova: ', listaNova);

    this.setState({
      listaParcelas: listaNova,
      vlrTotalParc: 0,
      vlrDifParc: 0,
    });
  }

  calculaTotalParc = () => {
    let vlrTotalParc = 0
    for (var x in this.state.listaParcelas) {
      vlrTotalParc = vlrTotalParc + parseFloat(this.state.listaParcelas[x].tparc_valor);
    };
    let vlrDifParc = parseFloat((parseFloat(vlrTotalParc) - parseFloat(this.state.registro.nf_vlr_total)).toFixed(2));
    this.setState({
      vlrTotalParc,
      vlrDifParc,
    });
  }

  onFecharModalParcela = () => {
    this.setState({
      modalParcelaVisible: false,
    },
      this.calculaTotalParc()
    );
  }

  onEditarParcelaClick = registro => {
    if (((this.state.listaParcelas) && (this.state.listaParcelas.length > 0)) || (String(this.state.nf_cond_pagto.key) === String(this.state.usuario.par_cond_pagto_informada))) {
      this.setState({
        modalParcelaVisible: true,
      });
    } else {
      Modal.warning({ title: 'Aviso!', content: 'Calcule as Parcelas para Editar' });
    }
  };

  excluirParcelas = () => {
    this.setState({
      listaParcelas: [],
      vlrTotalParc: 0,
      vlrDifParc: 0,
    });
  }

  // ----------------------------------------------------------------
  // FIM PARCELAS
  // ----------------------------------------------------------------








  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { registro } = this.state;
    registro[id] = value;
    this.setState({ [id]: value });
  };

  onChangePessoa = event => {
    const { registro } = this.state;
    registro['nf_destinatario'] = event.nf_destinatario;
    this.setState(event);
  }

  onDateEmissaoChange = event => {
    const { registro } = this.state;
    registro['nf_dt_emissao'] = String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    this.setState({ nf_dt_emissao: String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY')) });
  }

  onDateEntSaiChange = event => {
    const { registro } = this.state;
    registro['nf_dt_inclusao'] = String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY'));
    this.setState({ nf_dt_inclusao: String(moment(event, 'YYYY-MM-DD').format('DD/MM/YYYY')) });
  }


  renderValor = (nf_vlr_total, registro) => {
    return (
      <span> {numeral(parseFloat(nf_vlr_total)).format('0,000.00')} </span>
    );
  };

  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY')}
        </span>
      )
    } else {
      <span></span>
    }
  }

  onChangeTipoDoc = event => {
    const { registro } = this.state;
    registro['nf_tipo_doc'] = event.nf_tipo_doc;
    this.state.listaParcelas = [];
    this.setState(event);
  }

  onChangeCondPagto = event => {
    const { registro } = this.state;
    registro['nf_cond_pagto'] = event.nf_cond_pagto;
    this.state.listaParcelas = [];
    this.setState(event);
  }


  onChangeTabs = (activeKey) => {
    this.setState({ activeKey });
  }

  onCadPessoaClick = () => {
    this.setState({
      modalListaVisible: true,
      tipoPessoa: 'clientes'
    });
  }

  onCadTranspClick = () => {
    this.setState({
      modalListaVisible: true,
      tipoPessoa: 'transportadoras'
    });
  }

  onFecharModalLista = () => {
    this.setState({
      modalListaVisible: false,
    });
  }












  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------
  // ------------------------------------------------------------------



  render() {
    const { onCancelarNFServClick, carregando, visivel } = this.props;

    const { usuario, carregandoForm, visualizando, listaServicos, listaParcelas, servicoSelecionado, OPCOES_COMBO_EMITENTE,
      vlrDifParc, vlrTotalParc, caixaFechado, modalListaVisible, modalParcelaVisible, modalServicoVisible, tipoPessoa } = this.state;

    const { nf_idf, nf_numero, nf_serie, situacao_nota, nf_tipo, nf_destinatario, nf_obs_interna, nf_dt_emissao, nf_chave, nf_tipo_doc, nfinf_texto, nf_cond_pagto, nf_emitente,
      nf_vlr_total, nf_vlr_desconto, nf_vlr_iss, nf_vlr_csll, nf_vlr_inss, nf_vlr_irrf, nf_vlr_produtos,
    } = this.state.registro;

    // console.log('NotaFiscalServicoEmissaoForm.this.state: ', this.state);

    return (
      <Modal
        title={nf_idf ? (visualizando ? "Nota Fiscal de Serviço" : "Edição de Nota Fiscal de Serviço") : "Inclusão de Nota Fiscal de Serviço"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarNFServClick}
        footer={null}
        width={"60%"}
        style={{ top: 10 }}
      >

        <ModalPadraoForm
          visivel={modalListaVisible}
          telaModal={tipoPessoa}
          valorTotal={0}
          onFecharClick={this.onFecharModalLista}
        />

        <NotaFiscalServicoItemForm
          visivel={modalServicoVisible}
          onSalvarServicoClick={this.onSalvarServicoClick}
          onFecharModalServicoClick={this.onFecharModalServicoClick}
          servicoSelecionado={servicoSelecionado}
        />

        <TituloParcelaForm
          visivel={modalParcelaVisible}
          onFecharClick={this.onFecharModalParcela}
          listaParcelas={listaParcelas}
          valor_Total={nf_vlr_total}
          condPagto={nf_cond_pagto}
        />

        <SpinnerForm visivel={carregando} texto={'Transmitindo Nota. Aguarde...'} />



        <Row>
          <Row>
            <Col xs={24} sm={4} className="camposEspacoDireita">
              <span>Numero</span>
              <InputForm
                id="nf_numero"
                ref="nf_numero"
                maxLength={9}
                onChange={this.onChange}
                value={nf_numero}
                readOnly
              />
            </Col>
            <Col xs={24} sm={4} className="camposEspacoDireita">
              <span>Série</span>
              <InputForm
                id="nf_serie"
                ref="nf_serie"
                maxLength={9}
                onChange={this.onChange}
                value={nf_serie}
                readOnly
              />
            </Col>
            <Col xs={24} sm={4} className="camposEspacoDireita">
              <span>Situação</span>
              <InputForm
                id="situacao_nota"
                ref="situacao_nota"
                maxLength={20}
                onChange={this.onChange}
                value={situacao_nota}
                readOnly
              />
            </Col>
            <Col xs={24} sm={3} className="camposEspacoDireita">
              <span>Origem</span>
              <InputForm
                id="nf_tipo"
                ref="nf_tipo"
                maxLength={20}
                onChange={this.onChange}
                value={nf_tipo}
                readOnly
              />
            </Col>
            <Col xs={24} sm={9} style={{}}  >
              <span>Chave</span>
              <InputForm
                id="nf_chave"
                ref="nf_chave"
                maxLength={9}
                onChange={this.onChange}
                value={nf_chave}
                readOnly
              />
            </Col>

            <Col xs={24} sm={11} style={{ marginTop: -20 }}>
              <PessoaFrame
                label="Destinatário *"
                id="nf_destinatario"
                value={nf_destinatario}
                tipo="C"
                width={"100%"}
                onChange={this.onChangePessoa}
                disabled={caixaFechado || nf_tipo !== 'NFSe'}
                descricaoPrimeiroItem="Selecione um Destinatário"
              />
            </Col>
            <Col xs={24} sm={1} style={{ marginTop: 4, paddingRight: 20 }}>
              <Tooltip title="Cadastro de Clientes" placement="topLeft">
                <Button
                  type="dashed"
                  icon="plus"
                  htmlType="button"
                  onClick={() => this.onCadPessoaClick()}
                  disabled={visualizando}
                />
              </Tooltip>
            </Col>
            <Col xs={24} sm={12} style={{ marginTop: -20 }}>
              <span>Emissor *</span>
              <InputForm
                type="select"
                id="nf_emitente"
                ref="nf_emitente"
                value={nf_emitente}
                placeholder="Selecione o Tipo"
                onChange={this.onChangeEmitente}
                data={OPCOES_COMBO_EMITENTE}
                validator={value => Boolean(value)}
                style={{ width: "100%" }}
                showSearch
              />
            </Col>
            <Col xs={24} sm={6} style={{ marginTop: -16 }} className="camposEspacoDireita">
              <span>Data Emissão *</span>
              <DatePicker
                onChange={this.onDateEmissaoChange}
                format="DD/MM/YYYY"
                showToday={true}
                allowClear={false}
                value={moment(nf_dt_emissao, "DD/MM/YYYY", true)}
                style={{ width: "100%" }}
                disabled={caixaFechado || nf_tipo !== 'NFSe'}
              />
            </Col>
            <Col xs={24} sm={12} style={{ marginTop: -20 }} >
              <span>OBS Interna</span>
              <InputForm
                id="nf_obs_interna"
                ref="nf_obs_interna"
                maxLength={200}
                onChange={this.onChange}
                value={nf_obs_interna}
              />
            </Col>

          </Row>

          <div className="divider-lg-form" />

          <Tabs
            type="card"
            activeKey={this.state.activeKey}
            onChange={this.onChangeTabs}
            tabBarStyle={{ color: Colors.primary, fontWeight: 'bold' }}
          >

            <TabPane tab="Serviços da Nota" key="servicos">
              <div style={{ height: 250 }}>
                {visualizando ? null : (
                  <Row>
                    <Col xs={24} style={{ marginTop: -60 }}>
                      <Button
                        type="primary"
                        htmlType="button"
                        onClick={this.onNovoServico}
                        icon="plus"
                        className="btn-primary"
                      > Novo Serviço
                      </Button>
                    </Col>
                  </Row>
                )}
                <Table
                  loading={{
                    spinning: carregandoForm,
                    tip: 'Carregando. Aguarde...',
                    size: "large"
                  }}
                  dataSource={listaServicos}
                  pagination={false}
                  scroll={{ y: 320 }}
                  rowKey={(listaServicos => listaServicos.nfs_servico)}
                >
                  <Column
                    key="nfs_cod_servico"
                    dataIndex="nfs_cod_servico"
                    title="Código"
                    width={60}
                    align="center"
                    className="listaCadastro"
                  />
                  <Column
                    key="nfs_cod_nbs"
                    dataIndex="nfs_cod_nbs"
                    title="NBS"
                    width={60}
                    align="center"
                    className="listaCadastro"
                  />
                  <Column
                    key="nfs_descricao"
                    dataIndex="nfs_descricao"
                    title="Descrição"
                    width={200}
                    align="left"
                    className="listaCadastro"
                  />
                  <Column
                    key="nfs_qtde"
                    dataIndex="nfs_qtde"
                    title="Qtde"
                    render={this.renderValor}
                    width={60}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="nfs_vlr_unit"
                    dataIndex="nfs_vlr_unit"
                    title="Vlr Unit"
                    render={this.renderValor}
                    width={60}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="nfs_vlr_desc"
                    dataIndex="nfs_vlr_desc"
                    title="Vlr Desc"
                    render={this.renderValor}
                    width={60}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="nfs_vlr_total"
                    dataIndex="nfs_vlr_total"
                    title="Vlr Total"
                    render={this.renderValor}
                    width={60}
                    align="right"
                    className="listaCadastro"
                  />
                  <Column
                    key="acoes"
                    title=""
                    render={this.renderAcoesServicos}
                    width={70}
                    align="center"
                    className="listaCadastro"
                  />
                </Table>
              </div>
            </TabPane>


            <TabPane tab="Inf. Complementares" key="infCompl">
              <div style={{ height: 250 }}>
                <Row>
                  <Col xs={24} style={{}}>
                    <span>Informações complementares de interesso do contribuinte</span>
                    <InputForm
                      id="nfinf_texto"
                      ref="nfinf_texto"
                      value={nfinf_texto}
                      type="textarea"
                      rows={9}
                      maxLength={9500}
                      onChange={this.onChange}
                      validator={value => Boolean(value)}
                    />
                  </Col>
                </Row>
              </div>
            </TabPane>



            <TabPane tab="Cobrança" key="formaPagto">
              <div style={{ height: 250 }}>

                <Row>
                  {this.state.visualizando || caixaFechado ? null : (
                    <Row>
                      <Col xs={24} sm={10} style={{ marginTop: 0 }} className="camposEspacoDireita">
                        <TipoDocFrame
                          label="Tipo Documento"
                          id="nf_tipo_doc"
                          value={nf_tipo_doc}
                          width={"100%"}
                          onChange={this.onChangeTipoDoc}
                          descricaoPrimeiroItem="Informe o Tipo de Documento"
                        />
                      </Col>
                      <Col xs={24} sm={10} style={{ marginTop: 0 }}>
                        <CondPagtoFrame
                          label="Condição de Pagamento"
                          id="nf_cond_pagto"
                          value={nf_cond_pagto}
                          width={"100%"}
                          onChange={this.onChangeCondPagto}
                          descricaoPrimeiroItem="Informe a Condição de Pagamento"
                        />
                      </Col>
                      <Col xs={24} sm={1} style={{ marginTop: 19, marginLeft: 10 }}>
                        <Tooltip title="Calcular Parcelas">
                          <Button
                            type="primary"
                            htmlType="button"
                            onClick={this.montaParcelas}
                            icon="calculator"
                            className="btn-primary"
                          />
                        </Tooltip>
                      </Col>
                      <Col xs={24} sm={1} style={{ marginTop: 19, marginLeft: 10 }}>
                        <Tooltip title="Editar Parcelas">
                          <Button
                            type="primary"
                            htmlType="button"
                            onClick={this.onEditarParcelaClick}
                            icon="edit"
                            className="btn-primary"
                          />
                        </Tooltip>
                      </Col>
                      <Col xs={24} sm={1} style={{ marginTop: 19, marginLeft: 10 }}>
                        <Tooltip title="Excluir Parcelas">
                          <Button
                            type="primary"
                            htmlType="button"
                            onClick={this.excluirParcelas}
                            icon="close"
                            className="btn-primary"
                          />
                        </Tooltip>
                      </Col>
                    </Row>
                  )}

                  {vlrDifParc === 0 ? null : (
                    <Row style={{ marginLeft: 30, marginTop: 10, marginBottom: 10, }}>
                      <Col xs={24}>
                        <Col xs={24} sm={6}>
                          <span style={{ fontWeight: "bold" }}>Valor Total: </span>
                          <span>{this.renderValor(nf_vlr_total)}</span>
                        </Col>
                        <Col xs={24} sm={6}>
                          <span style={{ fontWeight: "bold" }}>Valor Parcelas: </span>
                          <span>{this.renderValor(vlrTotalParc)}</span>
                        </Col>
                        <Col xs={24} sm={6}>
                          <span style={{ color: "red", fontWeight: "bold" }}>Valor Diferença: </span>
                          <span>{this.renderValor(vlrDifParc)}</span>
                        </Col>
                      </Col>
                    </Row>
                  )}

                  <div>
                    <Table
                      loading={{
                        spinning: carregandoForm,
                        tip: 'Carregando. Aguarde...',
                        size: "large"
                      }}
                      dataSource={listaParcelas}
                      pagination={false}
                      scroll={{ y: 320 }}
                      rowKey={(listaParcelas => listaParcelas.tparc_parcela)}
                    >
                      <Column
                        key="tparc_parcela"
                        dataIndex="tparc_parcela"
                        title="Parcela"
                        width={60}
                        align="center"
                        className="listaCadastro"
                      />
                      <Column
                        key="tparc_data_parcela"
                        dataIndex="tparc_data_parcela"
                        title="Data Venc"
                        width={80}
                        align="center"
                        className="listaCadastro"
                        render={this.renderData}
                      />
                      <Column
                        key="tparc_valor"
                        dataIndex="tparc_valor"
                        title="Valor Parc"
                        render={this.renderValor}
                        width={80}
                        align="right"
                        className="listaCadastro"
                      />
                      <Column
                        key="situacao_parcela"
                        dataIndex="situacao_parcela"
                        title="Situação"
                        width={80}
                        align="center"
                        className="listaCadastro"
                      />
                      <Column
                        key="td_descricao"
                        dataIndex="td_descricao"
                        title="Tipo Documento"
                        width={300}
                        align="left"
                        className="listaCadastro"
                      />
                    </Table>
                  </div>
                </Row>

              </div>
            </TabPane>

          </Tabs>

          <div className="divider-lg-form" />

          <Row>
            <Col xs={24} sm={3} style={{ marginTop: 4, paddingRight: 20 }}>
              <span>Valor Serviços</span>
              <InputForm
                type="number"
                id="nf_vlr_produtos"
                ref="nf_vlr_produtos"
                value={nf_vlr_produtos}
                onChange={this.onChange}
                disabled={true}
              />
            </Col>
            <Col xs={24} sm={3} style={{ marginTop: 4, paddingRight: 20 }}>
              <span>Valor ISS</span>
              <InputForm
                type="number"
                id="nf_vlr_iss"
                ref="nf_vlr_iss"
                value={nf_vlr_iss}
                onChange={this.onChange}
                disabled={true}
              />
            </Col>
            <Col xs={24} sm={3} style={{ marginTop: 4, paddingRight: 20 }}>
              <span>Valor CSLL</span>
              <InputForm
                type="number"
                id="nf_vlr_csll"
                ref="nf_vlr_csll"
                value={nf_vlr_csll}
                onChange={this.onChange}
                disabled={true}
              />
            </Col>
            <Col xs={24} sm={3} style={{ marginTop: 4, paddingRight: 20 }}>
              <span>Valor INSS</span>
              <InputForm
                type="number"
                id="nf_vlr_inss"
                ref="nf_vlr_inss"
                value={nf_vlr_inss}
                onChange={this.onChange}
                disabled={true}
              />
            </Col>
            <Col xs={24} sm={3} style={{ marginTop: 4, paddingRight: 20 }}>
              <span>Vlr IRRF</span>
              <InputForm
                type="number"
                id="nf_vlr_irrf"
                ref="nf_vlr_irrf"
                value={nf_vlr_irrf}
                onChange={this.onChange}
                disabled={true}
              />
            </Col>
            <Col xs={24} sm={3} style={{ marginTop: 4, paddingRight: 20 }}>
              <span>Valor Desconto</span>
              <InputForm
                type="number"
                id="nf_vlr_desconto"
                ref="nf_vlr_desconto"
                value={nf_vlr_desconto}
                onChange={this.onChange}
                disabled={true}
              />
            </Col>
            <Col xs={24} sm={6} style={{ marginTop: 4, paddingRight: 20 }}>
              <span>Total Nota</span>
              <InputForm
                type="number"
                id="nf_vlr_total"
                ref="nf_vlr_total"
                value={nf_vlr_total}
                onChange={this.onChange}
                disabled={true}
              />
            </Col>
          </Row>

        </Row>

        <div>
          <div className="divider-form" />
          <ItemForm>
            <Row>
              <Col xs={24}>
                {this.state.visualizando || caixaFechado ? null : (
                  <Button
                    type="primary"
                    htmlType="button"
                    loading={carregando}
                    onClick={() => (
                      Modal.confirm({
                        title: 'Confirmação de Emissão',
                        content: `Deseja TRANSMITIR a Nota?`,
                        okText: 'Sim',
                        cancelText: 'Não',
                        onOk: () => this.onOK(1),
                        onCancel: () => this.onOK(0),
                      })
                    )}
                    className="btn-salvar"
                  >
                    Salvar Nota
                  </Button>
                )}
                <Button
                  htmlType="button"
                  onClick={onCancelarNFServClick}
                  className="btn-fechar"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>
        </div>

      </Modal >
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NotaFiscalServicoEmissaoForm.js